import { ApiClient } from '../client'
import { Customer, PaginatedResponse } from '../types'

export class CustomerApi {
  constructor(private client: ApiClient) {}

  async getProfile(): Promise<Customer> {
    // Note: customers endpoint returns data directly (idiomatic .NET pattern)
    const response = await this.client.get<any>('/v1/customers')
    
    // Handle wrapped or unwrapped response
    if (response && typeof response === 'object') {
      // If it has a data property, unwrap it
      if ('data' in response) {
        return response.data as Customer
      }
      // Otherwise assume it's the direct customer object
      return response as Customer
    }
    
    throw new Error('Invalid customer data format')
  }

  async updateProfile(data: Partial<Customer>): Promise<Customer> {
    return this.client.patch<Customer>('/v1/customers', data)
  }

  async getUsage(): Promise<{ 
    users_count: number
    organisations_count: number
    campaigns_count: number
    campaigns_this_month: number 
  }> {
    return this.client.get<any>('/v1/customers/usage')
  }

  async getSubscription(): Promise<{
    tier: string
    status: string
    valid_until: string
    features: string[]
  }> {
    return this.client.get<any>('/v1/customers/subscription')
  }

  // Admin endpoints
  async adminList(params: { 
    page?: number
    limit?: number
    status?: string 
  } = {}): Promise<PaginatedResponse<Customer>> {
    return this.client.get<PaginatedResponse<Customer>>('/admin/customers', params)
  }

  async adminGet(customerId: string): Promise<Customer> {
    const response = await this.client.get<any>(`/admin/customers/${customerId}`)
    return response?.data || response
  }
}
